module.exports = __webpack_public_path__ + "fd4fdf45ae4ea5f1a9b42f66fec516e6.jpg";